<template>
  <router-view
    v-if="
      ['users_sign_up_from_studio', 'users_wait_from_studio'].includes(
        $route.name
      )
    "
  />
  <div v-else class="app">
    <CHeader />
    <router-view v-if="$route.name === 'users_sign_up'" />
    <div v-else class="app__container">
      <router-view />
    </div>
  </div>
</template>

<script>
import CHeader from '@/components/common/CHeader/index.vue';
import Vue from 'vue';
import * as Sentry from '@sentry/vue';

Sentry.init({
  Vue: Vue,
  dsn: process.env['VUE_APP_SENTRY_DSN'],
  environment: process.env['NODE_ENV'],
  ignoreErrors: [
    'Network Error',
    'ERR_REDIRECT',
    'timeout of 0ms exceeded',
    'Illegal invocation',
    "Cannot read properties of undefined (reading 'sendEvents')",
    "Cannot read property 'sendEvents' of undefined",
    "Can't find variable: _AutofillCallbackHandler",
    /^Request failed with status code (40[1|6|]|422)$/
  ]
});

export default {
  components: {
    CHeader
  }
};
</script>

<style lang="scss">
.app {
  &__container {
    padding: 32px 32px 104px;
    max-width: 407px;
    margin: auto;

    @include mq() {
      max-width: 100%;
      padding: 32px 16px;
    }
  }
}
</style>
